(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rLoginTrezorProvider", [], factory);
	else if(typeof exports === 'object')
		exports["rLoginTrezorProvider"] = factory();
	else
		root["rLoginTrezorProvider"] = factory();
})(this, () => {
return 